import { h } from 'vue'
import { registrarFuncao } from '@/components/base/workflow/aprovacoes/aprovacoesRegistry'
import { formatarDataBR } from '@/utils/useDataBR'
import FiltrosPedidoVenda from './FiltrosPedidoVenda.vue'
import DetalhesCreditoPedidoVenda from './DetalhesCreditoPedidoVenda.vue'

const formatarValor = (valor) => {
  if (valor == null) return '-'
  try {
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor)
  } catch (e) {
    return valor?.toFixed(2) ?? '-'
  }
}

// Renderers para slots de coluna (componentes inline)
const slotRenderers = {
  resumoAprovacao: {
    props: ['row'],
    render () {
      return this.row.resumoSolicitacao || '-'
    }
  },
  acoes: {
    props: ['row', 'abrirModal'],
    render () {
      return h('div', { class: 'd-flex justify-content-end gap-1 acoes-wrapper' }, [
        h('button', {
          class: 'btn btn-sm btn-outline-info',
          onClick: () => this.abrirModal(this.row),
          title: 'Analisar'
        }, [
          h('i', { class: 'bi bi-search me-1' }),
          ' Analisar'
        ])
      ])
    }
  }
}

const definicao = {
  chave: 'PedidoVendaCredito',
  titulo: 'Aprovação de Crédito - Pedidos de Venda',
  subtitulo: 'Análise e aprovação de crédito para pedidos pendentes',
  apiEndpoint: '/WorkflowAprovacaoAnalise',
  entityKey: 'idWorkflowAprovacaoAnalise',
  campoHeader: 'resumoSolicitacao',
  endpointLista: '/pendentes?processo=WORK_APR_PROCESSO4',
  endpointAprovar: '/aprovar',
  endpointReprovar: '/reprovar',
  listasTabelas: ['WorkflowAprovacaoAnalise', 'PedidoVenda', 'PedidoVendaProduto', 'PedidoVendaCondicaoPg', 'Parceiro'],
  nomeEntidade: 'solicitação de aprovação de crédito',
  nomeEntidadeTitle: 'Solicitação de Aprovação de Crédito',

  formatarValor,

  colunas: [
    { field: 'idWorkflowAprovacaoAnalise', label: '#', width: 80, sortable: true, formatter: (v, row) => '#' + row.idWorkflowAprovacaoAnalise },
    { field: 'resumoSolicitacao', label: 'Resumo', sortable: false, slotName: 'resumoAprovacao' },
    { field: 'nomeSolicitante', label: 'Solicitante', sortable: false },
    { field: 'tsEnviadoAprovacao', label: 'Enviado', align: 'center', sortable: true, formatter: (v, row) => formatarDataBR(row.tsEnviadoAprovacao) },
    { field: 'nomeGrupoAprovador', label: 'Grupo', sortable: false },
    { field: 'nomeAprovador', label: 'Aprovador', sortable: false },
    { field: 'acoes', label: 'Ações', width: 120, align: 'right', slotName: 'acoes', resizable: false, sortable: false }
  ],

  // Renderers para slots de coluna
  slotRenderers,

  // Componentes dos slots
  componenteFiltros: FiltrosPedidoVenda,
  componenteDetalhesEnxuto: DetalhesCreditoPedidoVenda,
  componenteDetalhesCompleto: DetalhesCreditoPedidoVenda,

  // Mensagens do modal
  modalTitulo: 'Análise da Solicitação de Crédito',
  modalTamanho: 'xl',
  modalCorHeader: 'var(--bs-info)',

  // Mensagens de confirmação
  confirmacaoReprovarTitulo: 'Reprovar Solicitação de Crédito',
  confirmacaoReprovarMensagem: 'Tem certeza que deseja <strong>reprovar</strong> esta solicitação de aprovação de crédito?<br><br><textarea id="observacaoReprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',
  confirmacaoAprovarTitulo: 'Aprovar Solicitação de Crédito',
  confirmacaoAprovarMensagem: 'Tem certeza que deseja <strong>aprovar</strong> esta solicitação de aprovação de crédito?<br><br><textarea id="observacaoAprovacao" class="form-control" rows="3" placeholder="Observação (opcional)..." style="text-align: left; font-size: 0.9rem;"></textarea>',

  // Visão única (sem toggle enxuto/completo)
  visaoUnica: true,

  // Textos do grid
  emptyMessage: 'Nenhuma solicitação de aprovação de crédito pendente encontrada.',
  hintMessage: 'Duplo clique na linha para analisar a solicitação',

  // Filtros padrão
  filtrosPadrao: {
    buscaResumo: '',
    idGrupoAprovador: null
  }
}

registrarFuncao('PedidoVendaCredito', definicao)

export default definicao
